module.exports = __webpack_public_path__ + "media/images/home/ad_rectangle_eo_min-1d49a80bf30f326adb4e819c02781d78.jpg";